export default "__VITE_ASSET__2381d576__"